/**
 * Toggle hide or show element when clicked
 */
angular.module('gateApp').component('swAppLink', {
  template: require('./sw-app-link.html').default,
  bindings: {
    applications: '<',
  },
  controller: function () {
    const $ctrl = this;

    $ctrl.$onInit = () => {
      $ctrl.applications = [];
    };

    $ctrl.$doCheck = () => {
      $ctrl.hasSomeAccess = $ctrl.applications
        .filter((app) => app.hasAccess)
        .reduce(() => true, false);

      $ctrl.applications = $ctrl.applications.filter((app) => app.hasAccess);
    };
  },
});
